/* eslint-disable no-case-declarations */
import {
  FETCH_SIGNAL_BY_ID_FAILURE,
  FETCH_SIGNAL_BY_ID_REQUEST,
  FETCH_SIGNAL_BY_ID_SUCCESS,
  SIGNALS_ALERT_CHANGE_COMMON,
  UPDATE_SELECTED_ALERT,
  CLEAR_SIGNAL_EDIT,
} from '../../../constants/ActionTypes';
import { updateSignalAlertData } from './updators';

function defaultData() {
  return {
    data: {},
    isFetching: false,
    error: null,
    updateTime: new Date(),
    selectedAlert: undefined,
  };
}

const editSignal = (
  state = {
    ...defaultData(),
  },
  action
) => {
  switch (action.type) {
    case FETCH_SIGNAL_BY_ID_REQUEST:
      return {
        ...state,
        isFetching: true,
        error: null,
      };
    case FETCH_SIGNAL_BY_ID_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: null,
        data: action.data.data,
        selectedAlert: action.selectedAlert,
        updateTime: new Date(),
      };
    case FETCH_SIGNAL_BY_ID_FAILURE:
      return { ...state, isFetching: false, error: action.error };
    case SIGNALS_ALERT_CHANGE_COMMON:
      const dataSignalsAlertChangeCommon = updateSignalAlertData(
        state,
        action.alertId,
        action.updatedData
      );

      let commonChangeAlerts = [];

      if (
        dataSignalsAlertChangeCommon &&
        dataSignalsAlertChangeCommon?.data &&
        dataSignalsAlertChangeCommon?.data?.signals &&
        dataSignalsAlertChangeCommon?.data?.signals?.length
      ) {
        commonChangeAlerts = dataSignalsAlertChangeCommon?.data?.signals;
      }

      let commonChangeSelectedAlert = undefined;

      if (
        state.selectedAlert &&
        commonChangeAlerts.some((item) => item.id === state.selectedAlert.id)
      ) {
        commonChangeSelectedAlert = commonChangeAlerts.find(
          (item) => item.id === state.selectedAlert.id
        );
      }

      return {
        ...state,
        data: dataSignalsAlertChangeCommon,
        selectedAlert: commonChangeSelectedAlert,
      };
    case UPDATE_SELECTED_ALERT:
      return { ...state, selectedAlert: action.data };
    case CLEAR_SIGNAL_EDIT:
      return { ...defaultData() };
    default:
      return state;
  }
};

export default editSignal;
